import * as React from 'react';
import { Grid, Button, Alert } from '../../common';
import StandardModal from '../../common/modals/StandardModal';


interface RenewalDecisionModalProps {
    visible: boolean;
    decision: 'approve' | 'delete';
    accountName: string;
    accountId?: number;
    pocDurationDays?: number | null;
    currentExpirationDate?: Date | null;
    inProgress?: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

const RenewalDecisionModal: React.FC<RenewalDecisionModalProps> = ({
    visible,
    decision,
    accountName,
    accountId,
    pocDurationDays,
    currentExpirationDate,
    inProgress,
    onConfirm,
    onCancel,
}) => {
    const isApprove = decision === 'approve';

    const newExpirationDate =
    currentExpirationDate && pocDurationDays
        ? new Date(
              currentExpirationDate.getTime() +
              pocDurationDays * 24 * 60 * 60 * 1000
          )
        : null;

    return (
        <StandardModal
            show={visible}
            onDismiss={onCancel}
            title={isApprove ? 'Approve PoC Extension' : 'Delete Account'}
            footer={
                <Grid variant="2up">
                    <Grid.Item>
                        <Button
                            variant="secondary"
                            onClick={onCancel}
                            disabled={inProgress}
                        >
                            Cancel
                        </Button>
                    </Grid.Item>
                    <Grid.Item>
                        <Button
                            onClick={onConfirm}
                            disabled={inProgress}
                        >
                            {isApprove ? 'Approve' : 'Delete Account'}
                        </Button>
                    </Grid.Item>
                </Grid>
            }
        >
            {isApprove ? (
                <>
                    <p>
                        You are about to approve the PoC extension for{' '}
                        {accountName} #{accountId}.
                    </p>

                    {pocDurationDays && (
                        <Alert
                            variant="warning"
                            className="no-alert-actions"
                            body={`The PoC period will be extended by ${pocDurationDays} days.${
                                newExpirationDate
                                    ? ` New expiration date: ${newExpirationDate.toLocaleDateString()}`
                                    : ''
                            }`}
                        />
                    )}
                </>
            ) : (
                <>
                    <p>
                        You are about to <strong>delete</strong> the account{' '}
                        {accountName} #{accountId}.
                    </p>

                    <Alert variant="error" className="no-alert-actions" body={`
                                By denying this PoC extension the account will be deleted. This action cannot be
                                undone and all resources within the account will be lost.
                            `} />
                </>
            )}
        </StandardModal>
)};

export default RenewalDecisionModal;